import { useMemo } from 'react'

const TextMarquee = ({ items }) => {
  const segment = useMemo(() => {
    if (!items?.length) return []

    const expanded = [...items]
    while (expanded.length < 18) {
      expanded.push(...items)
    }
    return expanded
  }, [items])

  if (!segment.length) return null

  const renderGroup = (groupId) => (
    <div className="cinematic-marquee-group" aria-hidden={groupId === 'b' ? true : undefined}>
      {segment.map((item, i) => (
        <span key={`${groupId}-${item}-${i}`} className="cinematic-marquee-item">
          {item}
        </span>
      ))}
    </div>
  )

  return (
    <div className="cinematic-marquee" aria-hidden="true">
      <div className="cinematic-marquee-track">
        {renderGroup('a')}
        {renderGroup('b')}
      </div>
    </div>
  )
}

export default TextMarquee
